// extracted by mini-css-extract-plugin
export default {"crop-container":"ImageCropper-module--crop-container--BqQGl","controls":"ImageCropper-module--controls--25va4","slider":"ImageCropper-module--slider--5l6lo"};